import { useEffect } from 'react'
import { ConversationItemFragment } from '../../../../api/Fragments/ConversationItem.generated'

export const MessageEmitter = new EventTarget()

export function useOnMessage(cb: (item: ConversationItemFragment) => unknown) {
  return useEffect(() => {
    function listener(e: CustomEvent<ConversationItemFragment>) {
      return cb(e.detail)
    }

    MessageEmitter.addEventListener('message', listener)
    return () => MessageEmitter.removeEventListener('message', listener)
  }, [cb])
}
